import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IToast } from './toast.model';

@Injectable({
  providedIn: 'root'
})
export class NgToastService {

  toastDetails$ = new Subject<IToast>();

  constructor() { }

  success(message:IToast){
    this.toastDetails$.next(<IToast>{type:'success',detail:message.detail,position:message.position, summary:message.summary,duration:message.duration,sticky:message.sticky})
  }
  error(message:IToast){
    this.toastDetails$.next(<IToast>{type:'error',detail:message.detail,position:message.position,summary:message.summary,duration:message.duration,sticky:message.sticky})
  }
  info(message:IToast){
    this.toastDetails$.next(<IToast>{type:'info',detail:message.detail,position:message.position,summary:message.summary,duration:message.duration,sticky:message.sticky})
  }
  warning(message:IToast){
    this.toastDetails$.next(<IToast>{type:'warning',detail:message.detail,summary:message.summary,position:message.position,duration:message.duration,sticky:message.sticky})
  }
}
